import React, { useState } from 'react';
import GroupEditor from "../GroupEditor";
import useLocalStorage from "../../hooks/useLocalStorage";

function FixGrouping() {
    const [script, setScript] = useLocalStorage('fixGroupingScript', `function groupBy(array, property) {
const grouped = new Map();
array.forEach(item => {
    const key = item[property];
    grouped[key] = grouped[key] || [];
    grouped[key].push(item);
});
return grouped;
}
`);
    const [resultText, setResultText] = useState('');
    const [syntaxError, setSyntaxError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [resultTextCss, setResultTextCss] = useState('');
    const [srcDoc, setSrcDoc] = useState('');

    const testData = [
        { name: "Alice", group: "A" },
        { name: "Bob", group: "B" },
        { name: "Charlie", group: "A" }
    ];

    function calculateCorrectResult() {
        const correctFunction = (array, property) => {
            const grouped = new Map();
            array.forEach(item => {
                const key = item[property];
                if (!grouped.has(key)) {
                    grouped.set(key, []);
                }
                grouped.get(key).push(item);
            });
            return grouped;
        };
        return correctFunction(testData, 'group');
    }

    const correctResult = calculateCorrectResult();

    function executeScript() {
        setSyntaxError(false);
        setErrorMessage('');
        setResultText('');
        try {
            const scriptFunction = new Function(`
              let output = [];
              const input = ${JSON.stringify(testData)};
              function print(text) {
                output.push(text.toString());
              }
              ${script}
              const result = groupBy(input, 'group');
              print(JSON.stringify([...result]));
              return output[0] || "";
            `);
            const resultStr = scriptFunction();
            const resultArray = JSON.parse(resultStr);
            const resultMap = new Map(resultArray);
            const sortedKeys = [...resultMap.keys()].sort();
            const formattedOutput = sortedKeys
                .map(key => `<div>${key}: ${JSON.stringify(resultMap.get(key).map(item => item.name))}</div>`)
                .join('');
            setSrcDoc(`<!DOCTYPE html><html><body>${formattedOutput}</body></html>`);
            checkPassed(resultMap);
        } catch (e) {
            setSyntaxError(true);
            setResultTextCss('');
            setResultText("Ergebnis kann nicht ausgewertet werden, da dein Code noch einen oder mehrere Syntaxfehler hat:");
            setErrorMessage(e.message);
            setSrcDoc(`<div style="color: red;">Fehler: ${e.message}</div>`);
        }
    }


    function checkPassed(output) {

        //TODO check passed anpassen, damit funktionsweise gleich wie bei anderen Challenges ist
        // for (let i = 0; i < correctResult.length; i++) {
        //     if (correctResult.size === output.size) {
        //         setResultTextCss('error-message');
        //         setResultText("Deine Lösung ist leider falsch. Deine Gruppierung: " + JSON.stringify([...output]) + ". Erwartete Gruppierung: " + JSON.stringify([...correctResult]) + ".");
        //         return;
        //     }
        // }
        // setResultTextCss('success-result');
        // setResultText("Deine Lösung ist korrekt!");

        const userGrouping = [...output].map(([group, items]) => [
            group,
            items.map(item => item.name)
        ]);
        const expectedGrouping = [...correctResult].map(([group, items]) => [
            group,
            items.map(item => item.name)
        ]);

        let passed = true;

        if (output.size !== correctResult.size) {
            passed = false;
        } else {
            for (let [key, value] of correctResult) {
                if (!output.has(key) || JSON.stringify(output.get(key)) !== JSON.stringify(value)) {
                    passed = false;
                    break;
                }
            }
        }

        if (passed) {
            setResultTextCss('success-result');
            setResultText("Deine Lösung ist korrekt!");
        } else {
            setResultTextCss('error-message');
            setResultText("Deine Lösung ist leider falsch. Deine Gruppierung: " + JSON.stringify(userGrouping) + ". Erwartete Gruppierung: " + JSON.stringify(expectedGrouping) + ".");
        }
    }

    return (
        <>
            <div className="aufgaben-container">
                <h2>Kaputte Gruppierung</h2>
                <h3>Aufgabenstellung:</h3>
                Deine Aufgabe ist es, eine Funktion zu reparieren, die ein Array von Objekten basierend auf einer
                angegebenen Eigenschaft gruppiert.
                Momentan funktioniert die Gruppierung nicht korrekt, da die Ergebnisse in einem Objekt statt einer Map
                gespeichert werden.
                <br/><br/>
                Anforderungen:
                <ul>
                    <li>Die Gruppierung soll in einer Map gespeichert werden.</li>
                    <li>Alle Elemente, die denselben Wert für die angegebene Eigenschaft haben, sollen in einem Array
                        gruppiert werden.
                    </li>
                </ul>
                Sobald du deinen Code implementiert hast, kannst du ihn ausführen, um zu sehen, ob die Gruppierung
                korrekt ist.
            </div>

            <div className="aufgaben-container">
                <GroupEditor
                    language="javascript"
                    value={script}
                    onChange={setScript}
                    editorKey="fixGroupingScript"
                />
            </div>

            <button className="submit-code-button" onClick={executeScript}>▶ Code ausführen</button>

            <div className="ergebnis-text">
                Ergebnis: <br/>
                <div className={resultTextCss}>{resultText}</div>
                {syntaxError && <div className="error-message">{errorMessage}</div>}
            </div>

            <div className="result-frame">
                <iframe
                    title="console-output"
                    srcDoc={srcDoc}
                    sandbox="allow-scripts"
                    width="100%"
                    height="40%"
                />
            </div>
        </>
    );
}

export default FixGrouping;
